<div class="flex-column-center-full margin-top20">
    <h2>{{'Enter Room Number' | translate}}</h2>
    <input class="margin-top20" id='roomInput' #search type="text" (keyup.enter)="onClickControllerCard($event.target.value)" (input)="showError = false">
    <div class="red" *ngIf="showError"> {{'No room with that number' | translate}}!</div>
    <ion-button class="margin5" (click)="guestWithoutRoom()">{{'Guest without room' | translate}}</ion-button>
</div>

